import { getAuth } from 'firebase/auth'

const promiseRetry = require('promise-retry')

const errorMessage500 =
  'Something went wrong. We are probably already working on this problem. ' +
  'Feel free to reach out to monfort@labelium.com if you need assistance.'

export const apiCall = async (
  url: string,
  method: RequestInit['method'],
  body?: RequestInit['body'],
  isFormData = false,
  fullResponse = false,
  signal?: AbortSignal
) => {
  let idToken: string
  try {
    idToken = (await getAuth().currentUser?.getIdToken()) || ''
  } catch (error: any) {
    idToken = ''
  }

  const headers: RequestInit['headers'] = { Authorization: `Bearer ${  idToken}` }
  if (!isFormData) {
    headers['Content-Type'] = 'application/json'
  }
  // If isFormData, fetch method detect automatically the content-type. No need to declare it yourself


  return await promiseRetry(async (retry: Function, number: number) => {
      let response
      try {
        response = await fetch(
          url, { method, headers, credentials: 'same-origin', body, signal }
        )
      } catch(err) {
        if (err instanceof DOMException && err.name === 'AbortError') {
          throw err
        }
        // eslint-disable-next-line no-console
        console.info(`retrying after ${number} tries to ${method} ${url}.`)
        return retry(errorMessage500)
      }
      if (response.ok) {
        if (response.status === 204) { // No Content
          return
        }
        return await response.json()
      } if (response.status < 400 || response.status > 500){
        // eslint-disable-next-line no-console
        console.info(`retrying after ${number} tries to ${method} ${url}.`)
        retry(response.statusText)
      } else if (response.status === 500) {
          throw errorMessage500
      } else {
        if (fullResponse) {
          throw response
        }
        const data = await response.json()
        throw data.detail
      }
    },
    {
      retries: 1,
      minTimeout: 100,
      maxTimeout: 1000,
      randomize: true
    }
  )
}

/**
 * Streaming variant of apiCall — injects Firebase Bearer token but returns
 * the raw Response for ReadableStream consumption. No retry logic, no JSON parsing.
 */
export const apiCallStream = async (
  url: string,
  method: RequestInit['method'],
  body?: string,
  signal?: AbortSignal
): Promise<Response> => {
  let idToken: string
  try {
    idToken = (await getAuth().currentUser?.getIdToken()) || ''
  } catch (error: any) {
    idToken = ''
  }

  const headers: RequestInit['headers'] = {
    Authorization: `Bearer ${idToken}`,
    'Content-Type': 'application/json',
  }

  const response = await fetch(url, { method, headers, body, signal })

  if (!response.ok) {
    throw new Error(`Chat API error: ${response.status}`)
  }

  return response
}
